import { useEffect } from 'react';

const useGlobalStyles = (
  selector: string,
  className: string,
  toggle: boolean
) => {
  useEffect(() => {
    const element = document.querySelector(selector);

    if (!element) {
      console.error(`Element ${selector} is not found.`);
      return;
    }

    element?.classList.toggle(className, toggle);
  }, [toggle]);
};

export default useGlobalStyles;
